import {
  Box,
  Button,
  Checkbox,
  Code,
  Collapse,
  Flex,
  Table,
  TableTbody,
  TableTd,
  TableTh,
  TableThead,
  TableTr,
  Title,
} from '@mantine/core';
import { WithRecords } from '../wrappers/WithRecords';
import { License, page, remove, update } from '../api/licenses';
import { IconPencil, IconPlus, IconTrash } from '@tabler/icons-react';
import { useDisclosure } from '@mantine/hooks';
import { useParams } from 'react-router-dom';
import { WithApiKey } from '../wrappers/WithApiKey';
import { WithApp } from '../wrappers/WithApp';
import { Date } from '../components/Date';
import { useState } from 'react';

export const Licenses = () => {
  const [showDeleted, setShowDeleted] = useState(false);
  const { keyId } = useParams();
  const [opened, { toggle }] = useDisclosure(false);

  if (!keyId) {
    return <Box>Missing keyId</Box>;
  }

  return (
    <Box>
      <WithApiKey id={keyId}>
        {(key) => (
          <WithApp shortCode={key.scope} optional={true}>
            {(app) => (
              <Box>
                <Title order={3} mb={12}>
                  Licenses for: {key.scope}
                </Title>
                <Box mb="md">
                  <Checkbox
                    label="Show deleted"
                    checked={showDeleted}
                    onChange={() => setShowDeleted(!showDeleted)}
                  />
                </Box>
                <Flex mr={12} justify="space-between">
                  <Button
                    component="a"
                    href={`/api-keys/${encodeURIComponent(keyId)}/licenses/create`}
                    color="blue"
                    leftSection={<IconPlus />}
                  >
                    Add new License
                  </Button>
                </Flex>

                <WithRecords
                  getPage={page(keyId)}
                  remove={remove}
                  showDeleted={showDeleted}
                  filters={showDeleted ? { $showDeleted: 'true' } : {}}
                  restore={(token, id) =>
                    update(token, keyId, id, { deletedAt: null })
                  }
                >
                  {(results, removeItem, restoreItem) => (
                    <Table.ScrollContainer minWidth={500} mb="lg">
                      <Table>
                        <TableThead>
                          <TableTr>
                            {app?.requiredLicenseFields.map((field) => (
                              <TableTh key={field}>{field}</TableTh>
                            ))}
                            <TableTh>Created At</TableTh>
                            <TableTh>Updated At</TableTh>
                            <TableTh>Return Data</TableTh>
                            <TableTh></TableTh>
                          </TableTr>
                        </TableThead>
                        <TableTbody>
                          {results.map((result: License) => (
                            <TableTr key={result._id}>
                              {app?.requiredLicenseFields.map((field) => (
                                <TableTd key={field}>
                                  {result.matchData[field] ?? '-'}
                                </TableTd>
                              ))}

                              <TableTd>
                                <Date isoString={result.createdAt} />
                              </TableTd>
                              <TableTd>
                                <Date isoString={result.updatedAt} />
                              </TableTd>
                              <TableTd>
                                {result.returnDataString.length > 30 ? (
                                  <>
                                    <Collapse
                                      in={!opened}
                                      transitionDuration={0}
                                      transitionTimingFunction="linear"
                                    >
                                      <Code
                                        onClick={toggle}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        {result.returnDataString.substring(
                                          0,
                                          25
                                        )}
                                        ...more
                                      </Code>
                                    </Collapse>
                                    <Collapse
                                      in={opened}
                                      transitionDuration={300}
                                      transitionTimingFunction="linear"
                                    >
                                      <Code
                                        block
                                        onClick={toggle}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        {result.returnDataString}
                                      </Code>
                                    </Collapse>
                                  </>
                                ) : (
                                  <Code block>{result.returnDataString}</Code>
                                )}
                              </TableTd>
                              <TableTd>
                                <Flex justify="flex-end" gap="md">
                                  <Button
                                    leftSection={<IconPencil></IconPencil>}
                                    component="a"
                                    href={`/api-keys/${encodeURIComponent(
                                      keyId
                                    )}/licenses/${result._id}`}
                                  >
                                    Edit
                                  </Button>
                                  {result.deletedAt ? (
                                    <Button
                                      color="green"
                                      onClick={() => restoreItem(result._id)}
                                    >
                                      Restore
                                    </Button>
                                  ) : (
                                    <Button
                                      leftSection={<IconTrash />}
                                      color="red"
                                      onClick={() => removeItem(result._id)}
                                    >
                                      Remove
                                    </Button>
                                  )}
                                </Flex>
                              </TableTd>
                            </TableTr>
                          ))}
                        </TableTbody>
                      </Table>
                    </Table.ScrollContainer>
                  )}
                </WithRecords>
              </Box>
            )}
          </WithApp>
        )}
      </WithApiKey>
    </Box>
  );
};
